import axios from 'axios';
import hcpEnrollmentService from "../services/hcpEnrollmentService";
import { enrollmentStatusesValues } from 'shared/settings/constants';

export default {
	state: () => ({
		draft: [],
		pendingSignature: [],
		submitted: [],
		apiUrl: '/api/enrollments',
		statuses: [
			enrollmentStatusesValues.DRAFT,
			enrollmentStatusesValues.PENDING_SIGNATURE,
			enrollmentStatusesValues.SUBMITTED
		],
		ocUrl: '',
		icUrl: '',
		ostomyTypeLabel: '',
		continenceTypeLabel: '',
		isCareConnectUser: false,
		showFilters: false,
		enrollmentFilters: [],
		hasActiveFilters: false,
		searchTerm: '',
		activeActionsDropdownEnrollmentId: null,
		comfortMedicalOrderData: null,
		comfortMedicalOrderStatuses: [],
		isComfortMedicalOrderStatusesLoading: false,
		comfortMedicalOrderStatusesAbortController: null,
		isComfortMedicalEnabled: false
	}),
	getters: {
		getOstomyTypeLabel: (state) => {
			return state.ostomyTypeLabel;
		},
		getContinenceTypeLabel: (state) => {
			return state.continenceTypeLabel;
		},
		getOcUrl: (state) => {
			return state.ocUrl;
		},
		getIcUrl: (state) => {
			return state.icUrl;
		},
		getStatuses: (state) => {
			return state.statuses;
		},
		getDraftEnrollments: (state) => {
			return state.draft;
		},
		getPendingSignatureEnrollments: (state) => {
			return state.pendingSignature;
		},
		getCompletedEnrollments: (state) => {
			return state.submitted;
		},
		getIsCareConnectUser: (state) => {
			return state.isCareConnectUser;
		},
		getIsShowFilter: (state) => {
			return state.showFilters;
		},
		getDasboardFacetGroups: (state) => {
			return state.enrollmentFilters;
		},
		getHasActiveFilters: (state) => {
			return state.hasActiveFilters;
		},
		getEnrollmentsSearchTerm: (state) => {
			return state.searchTerm;
		},
		getActiveActionsDropdownEnrollmentId: (state) => {
			return state.activeActionsDropdownEnrollmentId;
		},
		getComfortMedicalOrderData: (state) => {
			return state.comfortMedicalOrderData;
		},
		getComfortMedicalOrderStatuses: (state) => {
			return state.comfortMedicalOrderStatuses;
		},
		getIsComfortMedicalOrderStatusesLoading: (state) => {
			return state.isComfortMedicalOrderStatusesLoading;
		}
	},
	mutations: {
		setOstomyTypeLabel: (state, type) => {
			state.ostomyTypeLabel = type;
		},
		setContinenceTypeLabel: (state, type) => {
			state.continenceTypeLabel = type;
		},
		setOCurl: (state, url) => {
			state.ocUrl = url;
		},
		setICurl: (state, url) => {
			state.icUrl = url;
		},
		setStatuses: (state, statuses) => {
			state.statuses = statuses;
		},
		setEnrollments: (state, payload) => {
			// get the correct status
			let currentStatus = hcpEnrollmentService.getStatusName(payload.status);
			state[currentStatus] = payload.data;
		},
		setIsCareConnectUser: (state, type) => {
			state.isCareConnectUser = type
		},

		setIsShowFilter: (state, isShow) => {
			state.showFilters = isShow;
		},
		setFilters: (state, filters) => {
			state.enrollmentFilters = filters
		},
		setHasActiveFilters: (state, status) => {
			state.hasActiveFilters = status
		},
		setEnrollmentsSearchTerm: (state, searchTerm) => {
			state.searchTerm = searchTerm ? searchTerm : '';
		},
		setActiveActionsDropdownEnrollmentId: (state, enrollmentId) => {
			state.activeActionsDropdownEnrollmentId = enrollmentId;
		},
		setIsComfortMedicalEnabled: (state, status) => {
			state.isComfortMedicalEnabled = status;
		},
		setComfortMedicalOrderData: (state, orderData) => {
			state.comfortMedicalOrderData = orderData;
		},
		setComfortMedicalOrderStatuses: (state, statuses) => {
			state.comfortMedicalOrderStatuses = statuses;
		},
		setIsComfortMedicalOrderStatusesLoading: (state, status) => {
			state.isComfortMedicalOrderStatusesLoading = status;
		}
	},
	actions: {
		fetchEnrollments: ({ commit, state, dispatch }, query) => {
			dispatch('showSpinner');
			let
				promises = [],
				statuses = [];

			state.statuses.forEach((status) => {
				promises.push(hcpEnrollmentService.getAll(state.apiUrl, status, query));
				let currentStatus = hcpEnrollmentService.getStatusName(status);
				statuses.push(currentStatus);
			});

			Promise.all(promises)
				.then(function ([...responses]) {
					responses.forEach((response, index) => {
						commit('setEnrollments', { data: response.data, status: statuses[index] });
					});
					dispatch('hideSpinner');
				})
				.then(() => {
					if ( state.isComfortMedicalEnabled ) {
						dispatch('fetchComfortMedicalOrderStatuses');
					}
				})
				.catch(errors => {
					dispatch('hideSpinner');
					console.error(errors);
				})
		},

		fetchEnrollmentFilters: ({dispatch, commit, state}) => {
			hcpEnrollmentService.getFilters(state.apiUrl)
				.then(({data}) => {
					commit('setFilters', data);
					dispatch('performFetchWithFiltersAndSearch')
				})
				.catch(errors => {
					console.error(errors);
				})
		},

		clearFilters: ({ commit, state }) => {
			state.enrollmentFilters.forEach((group) => {
				group.data.forEach((facet) => {
					facet.checked = false;
					if ( group.id === "date" ) {
						facet.value = ''
					}
				});
			});

			commit("setHasActiveFilters", false);
		},

		resetDashboardFacetGroups: ({ dispatch }) => {
			dispatch('clearFilters');

		 	dispatch('performFetchWithFiltersAndSearch');
		},

		// performFetchWithFilter for all endpoints
		performFetchWithFiltersAndSearch: ({ dispatch, commit, state }) => {
			let query = hcpEnrollmentService.getQueryFilters(state);

			dispatch('fetchEnrollments', query);
			if ( query.includes('type') || query.includes('dateFrom') || query.includes('dateto') || query.includes('modifiedByList') ) {
				commit("setHasActiveFilters", !!query);
			}
		},

		// performFetchWithFilter for specific endpoint
		// payload is an object with index and status, where status can be one of the following: 'Draft, EMRDraft' | 'PendingSignature' | 'Submitted, SubmittedUnsigned'
		fetchSpecificEndpointWithFilters: ({ state, dispatch }, payload) => {
			const queryParams = [];
			const query = hcpEnrollmentService.getQueryFilters(state);

			if (query) {
				queryParams.push(query);
			}

			if (payload.status === enrollmentStatusesValues.SUBMITTED && payload.activeSorting.iterate !== '') {
				queryParams.push(`sortby=${payload.activeSorting.iterate}&sortAscending=${payload.activeSorting.sortAscending}`);
			}

			if (payload?.index) {
				queryParams.push(`pagenumber=${payload.index}`);
			}

			const updateQuery = queryParams.join('&');

			dispatch('callSingleEndpoint', {payload, updateQuery});
		},

		// performFetchWithSorting for single endpoints
		fetchWithSorting: ({ state, dispatch }, payload) => {
			let query = hcpEnrollmentService.getQueryFilters(state);
			// concat query with page number
			const updateQuery = query.concat('', `${query ? '&' : ''}sortby=${payload.sort.iterate}&sortAscending=${payload.sort.sortAscending}`);

			// dispatch to callSingleEndpoint
			dispatch('callSingleEndpoint', {payload, updateQuery});
		},
		callSingleEndpoint: ({commit, state, dispatch}, options) => {
			// call specific endpoint ex: api/enrollments/GetAll?status=Draft,EMRDraft
			// with query filters and page number
			hcpEnrollmentService.getAll(state.apiUrl, options.payload.status, options.updateQuery)
				.then(result => {
					const statusIndex = (element) => element === options.payload.status;
					const index = state.statuses.findIndex(statusIndex)

					// commit and set the data to the correct status
					commit('setEnrollments', { data: result.data, status: state.statuses[index] });
				})
				.then(() => {
					if (state.isComfortMedicalEnabled && options.payload.status === enrollmentStatusesValues.SUBMITTED) {
						dispatch('fetchComfortMedicalOrderStatuses');
					}
				});
		},
		fetchComfortMedicalOrderDetails: ({ commit }, enrollmentId) => {
			commit('setComfortMedicalOrderData', null);
			const url = new URL(window.location.href);

			return hcpEnrollmentService.getComfortMedicalOrderDetails(url.origin, enrollmentId)
				.then(result => {
					if (result?.data) {
						commit('setComfortMedicalOrderData', result.data.patientOrders);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		fetchComfortMedicalOrderStatuses: ({ state, commit }) => {
			let params = '';
			commit('setComfortMedicalOrderStatuses', []);

			if (state.submitted?.enrollments?.length) {
				let paramsList = state.submitted.enrollments.map(enrollment => {
					return new URLSearchParams({ ids: enrollment.id }).toString();
				});
				params = paramsList.join('&');
			}

			if (params) {
				if (state.comfortMedicalOrderStatusesAbortController) {
					state.comfortMedicalOrderStatusesAbortController.abort();
				}
				state.comfortMedicalOrderStatusesAbortController = new AbortController();

				commit('setIsComfortMedicalOrderStatusesLoading', true);
				const url = new URL(window.location.href);
				hcpEnrollmentService.getComfortMedicalStatuses(url.origin, params, {
					signal: state.comfortMedicalOrderStatusesAbortController.signal,
				})
					.then(result => {
						commit('setIsComfortMedicalOrderStatusesLoading', false);
						if (result?.data) {
							commit('setComfortMedicalOrderStatuses', result.data);
						}
					})
					.catch(error => {
						if (!axios.isCancel(error)) {
							commit('setIsComfortMedicalOrderStatusesLoading', false);
							console.error(error);
						}
					});
			}
		},
	}
}
